import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=22c161c8&scoped=true"
import script from "./myheader.vue?vue&type=script&lang=js"
export * from "./myheader.vue?vue&type=script&lang=js"
import style0 from "./myheader.vue?vue&type=style&index=0&id=22c161c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c161c8",
  null
  
)

export default component.exports